import { staffClient } from "common/apis/staff";
import BasePageLayout from "components/Layout/BasePage";
import PagingTable, { EMPTY_PAGING_TABLE_RET } from "components/Table/Paging";
import PageTitle from "components/Title/Page";
import React from "react";
import { columns } from "./config";

const MemberList = () => {
    const fetchData = async (page, limit) => {
        try {
            const params = {
                offset: (page - 1) * limit,
                limit: limit
            }
            const ret = await staffClient.get("/member", { params });
            return {
                data: ret.data.data,
                total: ret.data.meta.total,
                page
            }
        } catch (e) {
            console.error("[MemberList] fetchData error", e);
            return EMPTY_PAGING_TABLE_RET;
        }
    }

    return (
        <BasePageLayout>
            <PageTitle>회원 목록</PageTitle>
            <PagingTable
                fetchData={fetchData}
                columns={columns}
            />
        </BasePageLayout>
    )
}

export default MemberList;
